import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IGenericResponse, ResponseStatus } from '../shared';
import { CompanySetting } from './store';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { tap, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { getTestBed } from '@angular/core/testing';
import { getTestServiceError } from '../shared';

@Injectable({
    providedIn: 'root'
})
export class CompanySettingService {
    private uri = `${environment.apiLocation}/CompanySetting`;

    constructor(private http: HttpClient, private log: LoggingService) {}
    public get(): Observable<Array<CompanySetting>> {
        return this.http.get<Array<CompanySetting>>(this.uri).pipe(
            tap(data =>
                this.log.verbose({
                    type: 'CompanySettingService:get',
                    data
                })
            ),
            map(this.mapSettings),
            tap(data =>
                this.log.verbose({
                    type: 'CompanySettingService:get:mapped',
                    data
                })
            )
        );
    }

    public put(
        settings: Array<Partial<CompanySetting>>
    ): Observable<IGenericResponse<CompanySetting>> {
        this.log.verbose({
            type: 'CompanySettingService:putCompanySetting',
            settings
        });
        // return getTestServiceError<CompanySetting>(49, settings as CompanySetting[], 'SettingType');
        return this.http
            .put<IGenericResponse<CompanySetting>>(this.uri, {
                CompanySettingList: [
                    ...settings.map(x => ({
                        SettingType: x.SettingType,
                        // SettingValue: s.SettingValue ? '1' : '0',
                        SettingValue:
                            x.CtrlType &&
                            x.CtrlType.toLocaleLowerCase() === 'checkbox'
                                ? x.SettingValue
                                    ? '1'
                                    : '0'
                                : x.SettingValue
                    }))
                ]
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type:
                            'CompanySettingService:putCompanySetting:response',
                        data
                    })
                ),
                map(resp => ({
                    ...resp,
                    Items: [...this.mapSettings(resp.Items)]
                })),
                tap(data =>
                    this.log.verbose({
                        type:
                            'CompanySettingService:putCompanySetting:response:mapped',
                        data
                    })
                )
            );
    }

    public getSetting(SettingType: string): Observable<Array<CompanySetting>> {
        return this.http
            .post<Array<CompanySetting>>(this.uri, {
                SettingType: SettingType
            })
            .pipe(
                map(this.mapSettings),
                tap(data =>
                    this.log.verbose({
                        type: 'CompanySettingService:getSetting',
                        data
                    })
                )
            );
    }
    mapSettings(settings: Array<CompanySetting>): Array<CompanySetting> {
        return settings.map(x => ({
            ...x,
            Validation: x.Isconfirmrequired ? 'confirm' : '',
            SettingValue:
                x.CtrlType.toLocaleLowerCase() === 'checkbox'
                    ? x.SettingValue === 'true' ||
                      x.SettingValue === true ||
                      x.SettingValue === 1 ||
                      x.SettingValue === '1'
                        ? '1'
                        : '0'
                    : x.SettingValue
        }));
    }
}
